import { render, staticRenderFns } from "./WithdrawalCertificates.vue?vue&type=template&id=77391f76&scoped=true"
import script from "./WithdrawalCertificates.vue?vue&type=script&lang=js"
export * from "./WithdrawalCertificates.vue?vue&type=script&lang=js"
import style0 from "./WithdrawalCertificates.vue?vue&type=style&index=0&id=77391f76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77391f76",
  null
  
)

export default component.exports